import { render, staticRenderFns } from "./HomeOportunities.vue?vue&type=template&id=4c932cd8&scoped=true&"
import script from "./HomeOportunities.vue?vue&type=script&lang=js&"
export * from "./HomeOportunities.vue?vue&type=script&lang=js&"
import style0 from "./HomeOportunities.vue?vue&type=style&index=0&id=4c932cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c932cd8",
  null
  
)

export default component.exports